"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerSapContactPricingZoneCreate = exports.HaulerSapContactPricingZoneTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.HaulerSapContactPricingZoneTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerSapContactId: typebox_1.Type.String({ format: 'uuid' }),
    pricingZoneId: typebox_1.Type.String({ format: 'uuid' }),
    metadata: common_1.MetaData,
});
exports.HaulerSapContactPricingZoneCreate = typebox_1.Type.Object({
    haulerSapContactId: typebox_1.Type.String({ format: 'uuid' }),
    pricingZoneId: typebox_1.Type.String({ format: 'uuid' }),
});
//# sourceMappingURL=hauler-sap-contact-pricing-zone.js.map